export const LineChartGridOptions = ['default', 'horizontal', 'full', 'none'] as const;
export type LineChartGridOptions = (typeof LineChartGridOptions)[number];

export const LineChartMarkerPointOptions = ['default', 'none'] as const;
export type LineChartMarkerPointOptions = (typeof LineChartMarkerPointOptions)[number];

export const LineChartYAxisOptions = ['default', 'left', 'right'] as const;
export type LineChartYAxisOptions = (typeof LineChartYAxisOptions)[number];

export const LineChartXAxisOptions = ['default', 'none'] as const;
export type LineChartXAxisOptions = (typeof LineChartXAxisOptions)[number];
